import React, { useState, useRef } from "react";

import AppCheckbox from "../AppCheckbox";
import TextInput from "../TextInput";

import searchIcon from '../../assets/images/searchIcon.svg'

import useToggle from "../useToggle.js";

import "./dropdown.styles.css";

const Dropdown = ({ dropdown_title, label, selectedOption, placeholder }) => {
  const [dropdownstate, setDropdowstate] = useState({
    visible: false,
  });

  const toggleDropdown = () => {
    setDropdowstate({ visible: !dropdownstate.visible });
  };

  const dropdownNode = useRef(null);
  useToggle(dropdownNode, dropdownstate.visible, setDropdowstate);



  return (
    <div className="dropdown__wrapper">
      <label>{label}</label>
      <div className="dropdown__input" onClick={toggleDropdown}>
        <span className="placeholder">
          {selectedOption ? selectedOption : placeholder}
        </span>
        <svg
          width="14"
          height="8"
          viewBox="0 0 14 8"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0.292893 0.292893C0.683417 -0.0976311 1.31658 -0.0976311 1.70711 0.292893L7 5.58579L12.2929 0.292893C12.6834 -0.0976311 13.3166 -0.0976311 13.7071 0.292893C14.0976 0.683418 14.0976 1.31658 13.7071 1.70711L7.70711 7.70711C7.31658 8.09763 6.68342 8.09763 6.29289 7.70711L0.292893 1.70711C-0.0976311 1.31658 -0.0976311 0.683418 0.292893 0.292893Z"
            fill="#C3C3C3"
          />
        </svg>
      </div>
      <div
        className={`${
          dropdownstate.visible
            ? "dropdown__wrapper--main"
            : "dropdown__wrapper--main is--hidden"
        }`}
        ref={dropdownNode}
      >
        <div className="">
          <h6>{dropdown_title}</h6>
          <TextInput
            type="text"
            placeholder="search for your role"
            icon={searchIcon}
            showLeftIcon
          />
        </div>
        <div className="dropdown__options mt--16">
          <div className="">
            <AppCheckbox label="Label" />
          </div>
          <div className="mt--24 mt--8">
            <AppCheckbox label="Label" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dropdown;
